import { Button, Grid, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CuiInputComponent: React.FC<any> = ({ client, updateClient }: any) => {
    const { t } = useTranslation();
    const [cui, setCui] = useState(client?.cui ?? '');

    const handleInputChange = (e: any) => {
        const updatedCui = e.target.value;
        setCui(updatedCui);

        // For new clients, to update the redux state
        if (!client.id) {
            updateClient({
                ...client,
                cui: updatedCui,
            });
        }
    };

    const handleOnEnter = (e: any) => {
        if (e.keyCode === 13 && client.id) {
            handleSaveCui();
        }
    };

    const handleSaveCui = () => {
        updateClient(
            {
                ...client,
                cui: cui,
            },
            t('cuiSaved'),
        );
    };

    return (
        <Grid container sx={{ mt: 2 }}>
            <Grid item xs={9}>
                <TextField
                    sx={{ width: '100%' }}
                    id="cui-input"
                    label={t('cui')}
                    placeholder="CUI"
                    variant="standard"
                    value={cui}
                    error={cui.length <= 0}
                    onChange={handleInputChange}
                    onBlur={handleInputChange}
                    onKeyDown={handleOnEnter}
                />
            </Grid>
            <Grid item xs={3}>
                {client.id && (
                    <Button
                        sx={{ mt: 1, width: '100%' }}
                        variant="contained"
                        disabled={cui.length <= 0 || cui === client?.cui}
                        onClick={handleSaveCui}
                    >
                        {t('saveCui')}
                    </Button>
                )}
            </Grid>
        </Grid>
    );
};

export default CuiInputComponent;
